export const eventHandlers = {
	PRODUCT_BUNDLE_DETAILS_PAGE_VIEW: 'PRODUCT_BUNDLE_DETAILS_PAGE_HIT',
};
